import { Box, Typography } from "@mui/material"
import PopUpModal, { popUpTypes } from "../popUp/popUpModal"
import { CloseIcon } from "../../iconRef/recipePageIcons"
import MediaPlayer from "../mediaPlayer/mediaPlayer"
import { resizeImageIfCloudinary } from "../../utils/images/cloudinaryUtils"
import UnitDisplay from "../ingredientsPage/unitDisplay"


const IngredientPrep = ({ open, onClose, ingredient }: { open: boolean, onClose: () => void, ingredient: any }) => {
    const prep = ingredient?.prep;
    const prepVideo = prep?.howMedia

    if (prepVideo?.length) {
        return (<PopUpModal
            open={open}
            onClose={onClose}
            popUpCategory={popUpTypes.INFO}
        >
            <IngredientsPrepCard ingredient={ingredient} onClose={onClose} />
            <Box sx={{ padding: "10px" }}>
                <Typography variant="subtitle2" sx={{ color: '#676767', pb: 1, textAlign: "center" }}>{ingredient?.prep?.displayName}</Typography>
                <MediaPlayer
                    url={prep?.howMedia}
                    muted={prep?.mute === "" ? false : prep?.mute}
                    duration={prep?.duration}
                    startTime={prep?.startTime}
                    loop={prep?.loop === "" ? false : prep?.loop}
                />
            </Box>
        </PopUpModal >)
    }

    return (<PopUpModal
        open={open}
        onClose={onClose}
        popUpCategory={popUpTypes.INGREDIENT}
    >
        <IngredientsPrepCard ingredient={ingredient} onClose={onClose} />
    </PopUpModal >)
}

const IngredientsPrepCard = ({ ingredient, onClose }: { ingredient: any, onClose: any }) => {
    const ingredientImage = resizeImageIfCloudinary(ingredient?.image, 77, 77, 77, 77, true)
    const alternateNames = ingredient?.alternateNames?.join(", ")
    const { weighScaleAmount } = ingredient;

    return (
        <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%" }}>
            <Box sx={{ backgroundColor: '#FFF3D0', height: '45px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', pl: '25%', boxSizing: 'border-box', mb: 1 }}>
                <Typography variant="body1" >Prep Ingredients</Typography>
                <Box sx={{ p: '15px' }} onClick={onClose}><CloseIcon /></Box>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-around", padding: "10px" }}>
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", maxWidth: "50%", gap: "7px" }}>
                    <Typography sx={{ textAlign: "center" }} variant="textBold">{ingredient?.displayName}</Typography>
                    {alternateNames && <>
                        <Typography variant="ingredientText1mini" sx={{ background: "#F7F2DE", padding: "4px 10px", borderRadius: "4px" }}>Other Names</Typography>
                        <Typography variant="ingredientText1mini" sx={{ textAlign: "center" }} >{alternateNames}</Typography>
                    </>}
                </Box>
                <Box sx={{ width: "30%" }} >
                    <img src={ingredientImage} alt="ingredient" />
                </Box>
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "20px" }}>
                <UnitDisplay weighScaleAmount={weighScaleAmount} ingredient={ingredient} />
            </Box>
        </Box >
    )
}


export default IngredientPrep;